import { useState, useEffect } from 'react';
import { nextDeliveryDate } from '../utils/next-delivery-date';
import { SummaryViewType  } from '../types/view/summary-view-type';
import { 
  SubscriptionsApiType,
  SubscriptionLineType,
  SubscriptionType
} from '../types/api/subscriptions-api-type';

const createSummary = (
  subscription: SubscriptionType
) => {

  const deliveryDate = nextDeliveryDate(
    [
      subscription.shop.disableDeliveryDaysSun,
      subscription.shop.disableDeliveryDaysMon,
      subscription.shop.disableDeliveryDaysTue,
      subscription.shop.disableDeliveryDaysWed,
      subscription.shop.disableDeliveryDaysThr,
      subscription.shop.disableDeliveryDaysFri,
      subscription.shop.disableDeliveryDaysSat,
    ],
    subscription.nextBillingDate,
    subscription.deliveryDays
  );
  const totalPrice =
    subscription.deliveryPriceAmount +
    subscription.subscriptionLines.reduce(
      (sum, subscriptionLine) => sum + subscriptionLine.currentPriceAmount * subscriptionLine.quantity,
      0
    );
  const totalOriginalPrice =
    subscription.deliveryPriceAmount +
    subscription.subscriptionLines.reduce(
      (sum, subscriptionLine) => sum + subscriptionLine.lineDiscountedPriceAmount * subscriptionLine.quantity,
      0
    );

  const selectedDeliveryTime = subscription.deliveryTime ? subscription.deliveryTime : 'AM';

  const enableDeliveryTimes = [
    {
      label: '午前中',
      value: 'AM',
      enabled: subscription.shop.enableDeliveryTimesAM,
      selected: selectedDeliveryTime === 'AM',
    },
    {
      label: '12:00〜14:00',
      value: '12',
      enabled: subscription.shop.enableDeliveryTimes12,
      selected: selectedDeliveryTime === '12',
    },
    {
      label: '14:00〜16:00',
      value: '14',
      enabled: subscription.shop.enableDeliveryTimes14,
      selected: selectedDeliveryTime === '14',
    },
    {
      label: '16:00〜18:00',
      value: '16',
      enabled: subscription.shop.enableDeliveryTimes16,
      selected: selectedDeliveryTime === '16',
    },
    {
      label: '18:00〜20:00',
      value: '18',
      enabled: subscription.shop.enableDeliveryTimes18,
      selected: selectedDeliveryTime === '18',
    },
    {
      label: '19:00〜21:00',
      value: '19',
      enabled: subscription.shop.enableDeliveryTimes19,
      selected: selectedDeliveryTime === '19',
    },
  ];

  return {
    nextBillingDate: subscription.nextBillingDate,
    deliveryDate,
    totalPrice,
    totalOriginalPrice,
    deliveryPrice: subscription.deliveryPriceAmount,
    enableDeliveryTimes: enableDeliveryTimes,
  };
};

const initialSummary: SummaryViewType = {
  nextBillingDate: new Date(),
  deliveryDate: new Date(),
  totalPrice: 0,
  totalOriginalPrice: 0,
  deliveryPrice: 0,
  enableDeliveryTimes: [{
    label: '',
    value: '',
    enabled: false,
    selected: false
  }]
};

export const useSummary = (
  subscriptions: SubscriptionsApiType | null
) => {
  const [summary, setSummary] = useState<SummaryViewType>(initialSummary);

  useEffect(() => {
    if (!subscriptions) return;

    const actives = subscriptions.filter(subscription => subscription.status === 'ACTIVE');

    if (actives.length === 0) {
      setSummary(initialSummary);
      return;
    }

    const createdSummary = createSummary(actives[0]);

    setSummary(createdSummary);

  }, [subscriptions]);

  return summary;
};
